<div class="content-with-filled-button">
    <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 px-0">
        <p class="title pt-5 mb-3">{{ copyService.copies.legal_requirements.title }}</p>
        <p class="subtitle mb-4">{{ copyService.copies.legal_requirements.subtitle }}</p>
        
        <div>
            <ul class="botton-line">
                <vcl-list >
                    <li *ngFor="let item of legal.list" vclListAction (click)="next()" >
                        <vcl-list-text>
                            <span class="description-list" [innerHTML]="item"></span>
                        </vcl-list-text>
                        <span class="icon icon-itaufonts_seta_right"></span>
                    </li>
                </vcl-list>
            </ul>
        </div>
    </div>
</div>
<app-controls class="mt-5" [hasPrevious]="false" [nextLabel]="copyService.copies.legal_requirements.continue" (next)="previous()"></app-controls>